"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _command = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/command"));
var _utils = require("./utils");
var ImageResizeCommand = exports.default = /*#__PURE__*/function (_Command) {
  function ImageResizeCommand() {
    (0, _classCallCheck2.default)(this, ImageResizeCommand);
    return (0, _callSuper2.default)(this, ImageResizeCommand, arguments);
  }
  (0, _inherits2.default)(ImageResizeCommand, _Command);
  return (0, _createClass2.default)(ImageResizeCommand, [{
    key: "refresh",
    value:
    /**
    * @inheritDoc
    */
    function refresh() {
      // const element = this.editor.model.document.selection.getSelectedElement()

      // this.isEnabled = isMediaWidget(element)
      // console.log('refresh-----', element, this.isEnabled)
      // if (!element || !element.hasAttribute('width')) {
      //   this.value = null
      // } else {
      //   this.value = {
      //     width: element.getAttribute('width'),
      //     height: null
      //   }
      // }
      // console.log('refresh-----', this.value)

      var model = this.editor.model;
      var selection = model.document.selection;
      var schema = model.schema;
      var position = selection.getFirstPosition();
      var selectedMedia = (0, _utils.getSelectedMediaModelWidget)(selection);
      var parent = position.parent;
      if (parent !== parent.root) {
        parent = parent.parent;
      }
      if (!selectedMedia || !selectedMedia.hasAttribute('width')) {
        this.value = null;
      } else {
        this.value = {
          width: selectedMedia.getAttribute('width'),
          height: null
        };
      }

      // this.value = selectedMedia ? selectedMedia.getAttribute('url') : null

      this.isEnabled = schema.checkChild(parent, 'media');
    }

    /**
    * Executes the command.
    *
    *		// Sets the width to 50%:
    *		editor.execute( 'imageResize', { width: '50%' } );
    *
    *		// Removes the width attribute:
    *		editor.execute( 'imageResize', { width: null } );
    *
    * @param {Object} options
    * @param {String|null} options.width The new width of the image.
    * @fires execute
    */
  }, {
    key: "execute",
    value: function execute(options) {
      var model = this.editor.model;
      var imageElement = model.document.selection.getSelectedElement();
      model.change(function (writer) {
        writer.setAttribute('width', options.width, imageElement);
      });
    }
  }]);
}(_command.default);